import i18next from 'i18next'

/** Know if the value passed is a number or not. */
export const isNumeric = (numberToTest: string) =>
    (typeof numberToTest === 'number' ||
        (typeof numberToTest === 'string' && numberToTest.trim() !== '')) &&
    !Number.isNaN(Number.parseFloat(numberToTest))

/** Get the number formatted depending on the locale and the options. */
export const getNumberFormatted = (
    number: number | string,
    options?: Intl.NumberFormatOptions,
): string => {
    const realNumber =
        typeof number === 'string' ? Number.parseFloat(number) : number

    return new Intl.NumberFormat(i18next.language, options).format(realNumber)
}

/** Get the price formatted. */
export const getPriceFormatted = (price: number | string): string => {
    return getNumberFormatted(price, {
        style: 'currency',
        currency: 'EUR',
        unitDisplay: 'narrow',
    })
}

/** Get the percentage formatted. */
export const getPercentageFormatted = (percentage: number): string => {
    return getNumberFormatted(percentage / 100, {
        style: 'percent',
        maximumFractionDigits: 1,
    })
}

/** Get the weight formatted. */
export const getWeightFormatted = (weight: number | string): string => {
    return getNumberFormatted(weight, {
        style: 'unit',
        unit: 'gram',
        unitDisplay: 'narrow',
        notation: 'compact',
    })
}
